'use strict';

angular.module('webmailWrapper')
    .controller('ChangePasswordCtrl', function($scope, mailboxModel, alertManager, emailAddress, translationProvider) {
        $scope.emailAddress = emailAddress;
        $scope.data = {
            oldPassword: '',
            password: '',
            passwordRepeat: ''
        };

        $scope.submit = function(form) {
            $scope.$broadcast('show-errors-check-validity');
            if (form.$invalid) {
                return;
            }

            mailboxModel.updateSecret($scope.data.oldPassword, $scope.data.password)
                .then(function() {
                    alertManager.success(translationProvider.instant('TR_070525-595b38_TR'));
                    $scope.data.oldPassword = '';
                    $scope.data.password = '';
                    $scope.data.passwordRepeat = '';
                }, function() {
                    alertManager.error(translationProvider.instant('TR_070525-548c8b_TR'));
                });
        };
    });
